import React, { Component } from "react";
import { connect } from "react-redux";
import { resetPasswords } from "../../../state/ducks/password/index";
import $ from "jquery";
import StaticModal from "../shared/StaticModal";

function formSifreKontrol() {
  var eskiSifre = $("#eski_sifre").val();
  var yeniSifre = $("#yeni_sifre").val();
  var yeniSifreTekrar = $("#yeni_sifre_tekrar").val();
  var durum = 1;
  //Eski Şifre boş mu kontrol
  if (eskiSifre == "") {
    durum = 0; // Konu Boş
    $("#eski_sifre").parent().addClass("t-error");
    $("#eskiSifre_hatamesaj").html("Eski Şifrenizi Giriniz.");
  } else {
    $("#eski_sifre").parent().removeClass("t-error");
    $("#eskiSifre_hatamesaj").html("");
  }
  //Yeni Şifre Kurallara Uygun mu
  if (yeniSifre == "") {
    durum = 0; // HATA VAR
    $("#yeni_sifre").parent().addClass("t-error");
    $("#yeniSifre_hatamesaj").html("Yeni Şifre alanını Boş Bırakamazsınız.");
  } else if (yeniSifre.length < 8) {
    durum = 0; // HATA VAR
    $("#yeni_sifre").parent().addClass("t-error");
    $("#yeniSifre_hatamesaj").html("Yeni Şifreniz en az 8 karakter olmalıdır.");
  } else if (yeniSifre.search(/[a-z]/) < 0) {
    durum = 0; // HATA VAR
    $("#yeni_sifre").parent().addClass("t-error");
    $("#yeniSifre_hatamesaj").html("Yeni Şifrenizde en az bir adet Küçük harf bulunmalıdır.");
  } else if (yeniSifre.search(/[A-Z]/) < 0) {
    durum = 0; // HATA VAR
    $("#yeni_sifre").parent().addClass("t-error");
    $("#yeniSifre_hatamesaj").html("Yeni Şifrenizde en az bir adet Büyük harf bulunmalıdır.");
  } else if (yeniSifre.search(/[0-9]/) < 0) {
    durum = 0; // HATA VAR
    $("#yeni_sifre").parent().addClass("t-error");
    $("#yeniSifre_hatamesaj").html("Yeni Şifrenizde en az bir adet Rakam İçermelidir.");
  } else if (yeniSifre.search(/[!@#$%^&*(_),.?:|<>-]/) < 0) {
    durum = 0; // HATA VAR
    $("#yeni_sifre").parent().addClass("t-error");
    $("#yeniSifre_hatamesaj").html("Yeni şifrelerinizde en az bir özel karakter (!@#$%^&*(_),.?:|<>-) bulunmalıdır.");
  } else {
    $("#yeni_sifre").parent().removeClass("t-error");
    $("#yeni_sifre_tekrar").parent().removeClass("t-error");
    $("#yeniSifre_hatamesaj").html("");
    $("#yeniSifreTekrar_hatamesaj").html("");
  }
  if (yeniSifre != yeniSifreTekrar) {
    durum = 0; // HATA VAR
    $("#yeni_sifre_tekrar").parent().addClass("t-error");
    $("#yeniSifreTekrar_hatamesaj").html("Yeni Şifreleriniz Aynı Olmalıdır.");
  } else {
    $("#yeni_sifre_tekrar").parent().removeClass("t-error");
    $("#yeniSifreTekrar_hatamesaj").html("");
  }
  // hata yok ise onay kutucuğu çıkart ve yoluna devam et
  return durum;

}

export class ResetPassword extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    reNewPassword: ""
  };
  loginShowOldPassword() {
    var loginPassword = document.getElementById("eski_sifre");
    var iconLoginPassword = document.getElementById("iconLoginOldPassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };


  loginShowNewPassword() {
    var loginPassword = document.getElementById("yeni_sifre");
    var iconLoginPassword = document.getElementById("iconLoginNewPassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };
  loginShowReNewPassword() {
    var loginPassword = document.getElementById("yeni_sifre_tekrar");
    var iconLoginPassword = document.getElementById("iconLoginRenewPassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };

  resetPasswords = event => {
    event.preventDefault();
    // eski şifre alanı
    if (formSifreKontrol() === 1) {

      this.props.resetPasswords(
        this.state.oldPassword,
        this.state.newPassword
      );
      this.setState({ oldPassword: "", newPassword: "", reNewPassword: "" });

    }
  };


  render() {
    return (
      <div className="container-fluid">
        {/* Yeşil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">

              <div
                className="col bosluk backtop"
                style={{
                  backgroundImage:
                    'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div className="col-12 d-flex justify-content-center pb-2">
                    <i className="t-icon-lock1 t-icGenelBaslikIcon" />
                  </div>
                  <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslik">
                    SİFRE BELİRLEME
                  </div>
                </div>
                {/* Eski Şifreniz */}
                <div className="row no-gutters">
                  <div className="col-12 pb-1">
                    <span className="t-icInputTitle pl-3 text-center text-success">
                      Eski Şifreniz
                    </span>
                  </div>
                  <div className="col-12">
                    <div className="t-icInput">
                      <div>
                        <i className="t-icon-lock1" />
                      </div>
                      <input
                        type="password"
                        placeholder="Eski Şifrenizi Giriniz"
                        name="eski_sifre"
                        id="eski_sifre"

                        value={this.state.oldPassword}
                        onChange={e => {
                          this.setState({ oldPassword: e.target.value });
                        }}
                      />
                      <div className="ml-auto">
                        <i
                          id="iconLoginOldPassword"
                          className="t-icon-eye-blocked t-cursorPointer"
                          onClick={this.loginShowOldPassword}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Mesaj Hata mesajının geleceği alan*/}
                  <div
                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                    id="eskiSifre_hatamesaj"
                  />
                  {/* Yeni Şifreniz */}
                  <div className="col-12 pb-1">
                    <span className="t-icInputTitle pl-3 text-center">
                      Yeni Şifreniz
                    </span>
                  </div>
                  <div className="col-12 ">
                    <div className="t-icInput">
                      <div>
                        <i className="t-icon-lock1" />
                      </div>
                      <input

                        placeholder="Yeni Şifrenizi Giriniz"
                        name="yeni_sifre"
                        id="yeni_sifre"
                        type="password"

                        value={this.state.newPassword}
                        onChange={e => {
                          this.setState({ newPassword: e.target.value });
                        }}
                      />
                      <div className="ml-auto">
                        <i
                          id="iconLoginNewPassword"
                          className="t-icon-eye-blocked t-cursorPointer"
                          onClick={this.loginShowNewPassword}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Mesaj Hata mesajının geleceği alan*/}
                  <div
                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                    id="yeniSifre_hatamesaj"
                  />
                  {/* Yeni Şifreniz Tekrar */}
                  <div className="col-12 pb-1">
                    <span className="t-icInputTitle pl-3 text-center">
                      Yeni Şifreniz Tekrar
                    </span>
                  </div>
                  <div className="col-12">
                    <div className="t-icInput">
                      <div>
                        <i className="t-icon-lock1" />
                      </div>
                      <input
                        type="password"
                        placeholder="Yeni Şifrenizi Tekrar Giriniz"
                        name="yeni_sifre_tekrar"
                        id="yeni_sifre_tekrar"

                        value={this.state.reNewPassword}
                        onChange={e => {
                          this.setState({ reNewPassword: e.target.value });
                        }}
                      />
                      <div className="ml-auto">
                        <i
                          id="iconLoginRenewPassword"
                          className="t-icon-eye-blocked t-cursorPointer"
                          onClick={this.loginShowReNewPassword}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Mesaj Hata mesajının geleceği alan*/}
                  <div
                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                    id="yeniSifreTekrar_hatamesaj"
                  />
                </div>
                {/* Değiştir*/}
                <div className="row no-gutters d-flex align-items-center justify-content-center mt-3">
                  <div className="col-auto px-1">
                    <button
                      type="button"
                      className="t-icButtonYesil"
                      onClick={this.resetPasswords}
                    >
                      <span />
                      <span className="pb-1">Değiştir</span>
                      <i
                        className="t-icon-arrow-right2"
                        style={{ fontSize: "14pt" }}
                      />
                    </button>
                  </div>
                </div>
                {/* içerikler BİTTİ */}
                <div className="row no-gutters d-flex flex-column justify-content-center mt-3 t-icAciklamaYazi">
                  <strong className="pb-2"> ŞİFRE DEĞİŞTİRME KURALLARI</strong>
                  <ol>
                    <li>
                      Şifreniz en az <strong>8</strong> karakter olmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir tane Küçük harf</strong> olmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir tane Büyük harf</strong> olmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir tane Rakam</strong> bulunmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir özel karakter (!@#$%^&*(),.?:{}|&lt;&gt;-_)</strong> bulunmalıdır.
                    </li>
                  </ol>

                </div>
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
        <StaticModal></StaticModal>
      </div>

    );
  }
}
const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  resetPasswords: (oldPassword, newPassword) =>
    dispatch(resetPasswords(oldPassword, newPassword))
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
